/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_TitleInputs */

const en_us2_gyms_title = /** @type {(inputs: Gyms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My gyms`)
};

const pt_br2_gyms_title = /** @type {(inputs: Gyms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas academias`)
};

const es_419_gyms_title = /** @type {(inputs: Gyms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis gimnasios`)
};

const pt_pt2_gyms_title = /** @type {(inputs: Gyms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os meus ginásios`)
};

const fr_fr2_gyms_title = /** @type {(inputs: Gyms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes salles`)
};

const de_de2_gyms_title = /** @type {(inputs: Gyms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Studios`)
};

const it_it2_gyms_title = /** @type {(inputs: Gyms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mie palestre`)
};

/**
* | output |
* | --- |
* | "My gyms" |
*
* @param {Gyms_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_title = /** @type {((inputs?: Gyms_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_title(inputs)
	if (locale === "es-419") return es_419_gyms_title(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_title(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_title(inputs)
	if (locale === "de-DE") return de_de2_gyms_title(inputs)
	if (locale === "it-IT") return it_it2_gyms_title(inputs)
	return en_us2_gyms_title(inputs)
});
export { gyms_title as "gyms.title" }